"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = require("react");

var _lottie_light = _interopRequireDefault(require("lottie-web/build/player/lottie_light"));

var _propTypes = require("prop-types");

var _animationData = _interopRequireDefault(require("./animationData"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Loading = function Loading(_ref) {
  var height = _ref.height,
      width = _ref.width,
      props = _objectWithoutProperties(_ref, ["height", "width"]);

  var myRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (myRef.current !== null) {
      _lottie_light["default"].loadAnimation({
        container: myRef.current,
        renderer: 'svg',
        animationData: _animationData["default"],
        loop: true,
        rendererSettings: {
          viewBoxSize: '85 110 120 60'
        }
      });
    }
  }, []);
  return (0, _jsxRuntime.jsx)("div", _objectSpread({
    ref: myRef,
    style: {
      maxWidth: width,
      height: height,
      margin: 'auto'
    },
    "aria-live": "assertive",
    "aria-label": "Do not refresh the page"
  }, props));
};

Loading.propTypes = {
  height: _propTypes.number,
  width: _propTypes.number
};
Loading.defaultProps = {
  height: 20,
  width: 40
};
var _default = Loading;
exports["default"] = _default;